import { useEffect } from 'react'
import { useDarkMode } from '../App'

export default function SidePanel({ open, onClose, children, title }:{ open:boolean; onClose:()=>void; children:any; title:string }){
  const { isDark } = useDarkMode()
  
  useEffect(()=>{
    const onEsc = (e:KeyboardEvent)=>{ if(e.key==='Escape') onClose() }
    document.addEventListener('keydown', onEsc)
    return ()=>document.removeEventListener('keydown', onEsc)
  },[onClose])

  if(!open) return null
  return (
    <div role="dialog" aria-modal="true" aria-label={title}>
      <div className="fixed inset-0 bg-black/30" onClick={onClose}/>
      <aside className={`fixed right-0 top-0 h-full w-full sm:w-[480px] shadow-2xl p-6 overflow-y-auto transition-colors ${
        isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
      }`}>
        <button 
          className={`mb-4 text-sm underline transition-colors ${
            isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
          }`} 
          onClick={onClose} 
          aria-label="Close"
        >
          Close
        </button>
        <h2 className={`text-xl font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          {title}
        </h2>
        {children}
      </aside>
    </div>
  )
}